import React, {Component, createContext} from 'react'

const context = createContext({})

const {Provider, Consumer} = context
export {Consumer}

class Form extends Component {
    constructor(props) {
        super(props);
        this.state = {...this.props.initialValues}
    }

    handleChange = name => event => {
        this.setState({[name]: event.target.value})
        if (this.props.handleChange) {
            this.props.handleChange({[name]: event.target.value})
        }
    };

    handleCheck = name => event => {
        this.setState({[name]: event.target.checked})
    };

    handleRadio = (name) => event => {
        this.setState({[name]: event.currentTarget.value});
    };

    handleSelect = name => event => {
        this.setState({[name]: event.value})
    };

    onSubmit = event => {
        event.preventDefault();
        this.props.onSubmit(this.state)
    };

    render() {
        return (
            <Provider
                value={{
                    handleChange: this.handleChange,
                    handleSelect: this.handleSelect,
                    handleCheck: this.handleCheck,
                    handleRadio: this.handleRadio,
                    formState: this.state,
                }}
            >
                <form className="__cta_tag" onSubmit={this.onSubmit.bind(this)}>
                    {this.props.children}
                </form>
            </Provider>
        )
    }
}

export default Form
